"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PublicConnectionSection;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _listings = require("../../../constants/listings");
var _config = _interopRequireDefault(require("../../../config"));
var _AdvisrListingConnectionSection = _interopRequireDefault(require("../common/AdvisrListingConnectionSection"));
var _SAPStoreListingConnectionSection = _interopRequireDefault(require("../common/SAPStoreListingConnectionSection"));
var _StandardPublicConnectionSection = _interopRequireDefault(require("./StandardPublicConnectionSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This is the component used for the connection section if there is no user logged in

function PublicConnectionSection(_ref) {
  var listingType = _ref.listingType,
    inquireURL = _ref.inquireURL,
    listingId = _ref.listingId,
    handleRequestInformationClick = _ref.handleRequestInformationClick,
    navigateToListingDeeplink = _ref.navigateToListingDeeplink;
  var isJouleListing = _config.default.nui.jouleListingId === listingId;
  if (listingType === _listings.LISTING_TYPES.ADVISR) {
    return isJouleListing ? /*#__PURE__*/_react.default.createElement(_SAPStoreListingConnectionSection.default, {
      onButtonClick: navigateToListingDeeplink,
      onSecondaryLinkClick: handleRequestInformationClick,
      listingId: listingId,
      showLoginButton: true
    }) : /*#__PURE__*/_react.default.createElement(_AdvisrListingConnectionSection.default, {
      onRequestInformationClick: handleRequestInformationClick,
      listingId: listingId
    });
  }
  return /*#__PURE__*/_react.default.createElement(_StandardPublicConnectionSection.default, {
    listingId: listingId,
    inquireURL: inquireURL,
    onListingDeeplinkClick: navigateToListingDeeplink,
    onRequestInformationClick: handleRequestInformationClick
  });
}
PublicConnectionSection.propTypes = {
  listingType: _propTypes.default.string.isRequired,
  // listing field
  inquireURL: _propTypes.default.string,
  // Listing field
  listingId: _propTypes.default.string.isRequired,
  // Listing field
  handleRequestInformationClick: _propTypes.default.func.isRequired,
  navigateToListingDeeplink: _propTypes.default.func.isRequired
};